import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, DialogContent, List, ListItemButton, ListItemText } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';
import { CarModel } from 'models/StockModel';
import useVoyagesFilter from 'modules/voyages/hooks/useVoyagesFilter';


type SelectVoyageDialogProps = {
    car: CarModel,
} & ModalActionProps<number>

const SelectVoyageDialog = ({car, onFinish}: SelectVoyageDialogProps) => {
    const {t} = useTranslation('cars');
    const filterFor = useVoyagesFilter();
    const voyages = filterFor(car);

    if (!voyages.length) {
        return (
            <DialogContent>
                <Alert severity="warning" sx={{mt:'1.25rem'}}>{t('no_voyage_wait')}</Alert>
            </DialogContent>
        )
    }

    return (
        <DialogContent>
            <List dense sx={{height: 100, overflow: 'auto',}}>
                {voyages.map(voyage => (
                    <ListItemButton
                        key={voyage.id}
                        onClick={() => onFinish(voyage.id)}
                    >
                        <ListItemText
                            primary={`${voyage.etd} ${voyage.vessel.name} ${voyage.number} ${t('to')} ${voyage.pod.name}`}
                        />
                    </ListItemButton>
                ))}
            </List>
        </DialogContent>
    );
};

export default SelectVoyageDialog;
